module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "icon main-path"
  }, [_vm._v("Main footpath")]), _vm._v(" "), _c('p', {
    staticClass: "icon second-path"
  }, [_vm._v("Secondary footpath")]), _vm._v(" "), _c('p', {
    staticClass: "icon desire-line"
  }, [_vm._v("Desire Line")]), _vm._v(" "), _c('p', {
    staticClass: "icon easy-trail"
  }, [_vm._v("Easy going trail (wheelchair accessible)")]), _vm._v(" "), _c('p', {
    staticClass: "icon footbridge"
  }, [_vm._v("Footbridge")]), _vm._v(" "), _c('p', {
    staticClass: "icon info"
  }, [_vm._v("Information board")]), _vm._v(" "), _c('p', {
    staticClass: "icon bench"
  }, [_vm._v("Bench")]), _vm._v(" "), _c('p', {
    staticClass: "icon flush"
  }, [_vm._v("Flush / Saturated soil")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4794974"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keys/MapKey.vue
// module id = 100
// module chunks = 1